import ApiClient from './ApiClient'
import { ContractorManagementType } from '../types/Entities/ContractorManagementType'

const getCompanyContractordetails  = async (apiClient: ApiClient):
  Promise<ContractorManagementType[]> => {
  return apiClient
    .get<ContractorManagementType[]>(`ContractorContactsDetail/getCompanyContractordetails`)
    .catch(error => { throw error })
}

const postCompanyContractorDetails  = async (apiClient: ApiClient, payload: ContractorManagementType[]):
  Promise<Response> => {
  return apiClient
    .post('ContractorContactsDetail/upsertCompanyContractor', JSON.stringify(payload))
    .catch(error => { throw error })
}

const contractorManagementApi = {
  getCompanyContractordetails, 
  postCompanyContractorDetails
}

export default contractorManagementApi